import React, { useEffect, useState } from "react";
import { Table, Modal, Space } from "antd";
import { getApprovalColumns } from "./approvalColumns";
import { useIntl } from "react-intl";
import moment from "moment";
import {
  approveEvent,
  editSchedulingEvent,
  deleteSchedulingEvent,
  deleteEvents,
  unlockEvents,
  transferSchedulingEvents,
} from "../../features/scheduling/schedulingSlice";
import { useDispatch, useSelector } from "react-redux";
import SchedulingApprovalWrapper from "./SchedulingApproval.style";
import _ from "lodash";
import {
  convertSchedulingEventsFromCalender,
  isSchedulingAllowedOverlapping,
  isLoadingHours,
  getItemsWithHeaders,
  getItemsWithNotScheduledDays,
  getEventsWithAbsences,
} from "../util/helpers";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import EmployeeSchedulingModal from "./EmployeeSchedulingModal";
import SelectionActions from "./SelectionActions";
import { usePermission } from "../../hooks/accessControl";
import { onApprove, onAction } from "./helper";
import TimewatchEventsTable from "../../features/employeeScheduling/components/TimewatchEventsTable";
import { useSuperAdmin } from "../../hooks/accessControl";
import TransferModal from "./TransferModal";

const SchedulingApproval = (props) => {
  const {
    filteredOrders,
    events,
    originalEvents,
    changeEvents,
    loadLoading,
    fromEmployee,
    reload,
    holidays,
    orders,
    absences,
    currentDate,
    quickEdit,
    timewatchEvents,
    showTimewatchEvents,
    isLoadingTimewatch,
  } = props;
  const intl = useIntl();
  const [items, setItems] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [changedEvents, setChangedEvents] = useState([]);
  const [activeSorter, setActiveSorter] = useState("start");
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [visible, setVisible] = useState(false);
  const [transferModalVisible, setTransferModalVisible] = useState(false);
  const isSuperAdmin = useSuperAdmin();
  const scopePrefix = useSelector((state) => state.user.scopePrefix);

  const patientId = useSelector(
    (state) => state.patientDetails.activePatient.id
  );
  const branchId = useSelector(
    (state) => state.patientDetails.activePatient.branch
  );

  const { conflict_events, employee_conflicts } = useSelector(
    (state) => state.employeeScheduling.page
  );

  const allowUpfrontApproval = useSelector(
    (state) => state.organization.details.allow_diaries_upfront_approval
  );

  const patientReligionId = useSelector(
    (state) => state.patientDetails.activePatient.religion_id
  );
  const employeeReligionId = useSelector(
    (state) => state.employeeDetails.activeEmployee.religion_id
  );
  const employeeBranches = useSelector(
    (state) => state.employeeDetails.activeEmployee?.active_branches || []
  );

  let religionId = fromEmployee ? employeeReligionId : patientReligionId;
  religionId = religionId || 1;
  const dispatch = useDispatch();
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    if (selectedRowKeys.length === 0) {
      setSelectedKeys([]);
    }
  }, [selectedRowKeys]);

  const invokeTabKey = () => {
    var currInput = document.activeElement;
    if (currInput.tagName.toLowerCase() === "input") {
      var inputs = document.getElementsByTagName("input");
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i] === currInput) {
          let next = inputs[i + 1];
          if (
            next &&
            (next.disabled || (quickEdit && next.type === "checkbox"))
          ) {
            next = inputs[i + 2];
          }
          if (next && next.focus) {
            next.focus();
          }
          break;
        }
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      invokeTabKey();
    }
  };

  useEffect(() => {
    let filtered = [];
    const data = fromEmployee
      ? getEventsWithAbsences(events, absences, currentDate)
      : events;
    data.forEach((item, i) => {
      var isFiltered = filteredOrders?.includes(
        fromEmployee ? item.order.id : item.order_id
      );
      if (!isFiltered) {
        filtered.push(item);
      }
    });
    if (quickEdit) {
      // setItems(filtered);
      setItems(getItemsWithNotScheduledDays(filtered, currentDate));
    } else {
      setItems(getItemsWithHeaders(filtered, activeSorter, intl));
    }
  }, [
    events,
    filteredOrders,
    activeSorter,
    fromEmployee,
    absences,
    currentDate,
    intl,
    quickEdit,
  ]);
  const onDateChange = (val, record) => {
    const newDate = moment(record.start).set("date", val);
    var foundIndex = events.findIndex((x) => x.id === record.id);
    let arr = [...events];
    const changedDate = newDate.format();
    const duration = moment(record["end"]).diff(record["start"], "minutes");
    const end = moment(newDate).clone();
    end.add(duration, "minutes");
    arr[foundIndex] = {
      ...record,
      date: changedDate,
      duration_minutes: duration,
      start: newDate.toDate(),
      end: end.toDate(),
    };

    const isAllowedOverlapping = checkIfAllowedOverlapping(
      events,
      record,
      newDate,
      end
    );
    if (isAllowedOverlapping) {
      showAlert(arr, record, changedDate, duration);
    } else {
      changeEvents(arr);
      shouldAddToChangedEvents(record, changedDate, duration);
    }
  };

  /**
   * Handles the change event for updating the start or end time of an event.
   *
   * @param {Object} time - The new time value.
   * @param {Object} record - The record object containing event details.
   * @param {string} field - The field being updated ("start" or "end").
   */
  const onChange = (time, record, field) => {
    const foundIndex = events.findIndex((x) => x.id === record.id);
    let arr = [...events];
    let start = moment(record["start"]);
    let end = moment(record["end"]);
    const isSameDay = start.isSame(end, "day");

    /**
     * Sets the time of a date object to the specified time's hours and minutes.
     *
     * @param {Object} date - The date object to be modified.
     * @param {Object} time - The time object from which hours and minutes are extracted.
     * @returns {Object} - The modified date object.
     */
    const setMinutesFromMidnight = (date, time) => {
      const minutesFromMidnight =
        moment(time).hours() * 60 + moment(time).minutes();
      return date.clone().startOf("day").minutes(minutesFromMidnight);
    };

    if (field === "start") {
      start = setMinutesFromMidnight(moment(record["date"]), time);

      // If the new start time is after the end time on the same day, or if both times are midnight (00:00) but on different days, reset the end time
      if (
        (start.diff(start.clone().startOf("day"), "minutes") >
          end.diff(end.clone().startOf("day"), "minutes") &&
          isSameDay) ||
        (start.hours() === 0 &&
          start.minutes() === 0 &&
          end.hours() === 0 &&
          end.minutes() === 0 &&
          !isSameDay)
      ) {
        end = null;
      }
    } else {
      // Handle end time changes
      const isMidnight =
        moment(time).hours() === 0 && moment(time).minutes() === 0;

      if (
        isMidnight &&
        moment(time).hours() * 60 + moment(time).minutes() <
          moment(start).hours() * 60 + moment(start).minutes()
      ) {
        // If selecting 00:00 and time is before start time (comparing only hours and minutes)
        end = moment(start).add(1, "day").startOf("day");
      } else {
        // Use the start date but with the selected end time
        const baseDate = moment(record["start"]).startOf("day");
        end = setMinutesFromMidnight(baseDate, time);
      }

      // Ensure end time is after start time
      if (end <= start && !isMidnight) {
        end = null;
      }
    }

    const date = field === "start" ? start.format() : record.date;
    const duration = end && end.diff(start, "minutes");

    // Update the event record if the end time is after the start time, or if the start time is being set
    if (end > start || field === "start") {
      arr[foundIndex] = {
        ...record,
        start: new Date(start),
        end: end > start ? new Date(end) : null,
        date: date,
        duration_minutes: duration,
      };

      const updatedStart = field === "start" ? start : record.start;
      const updatedEnd = end;
      const isAllowedOverlapping = checkIfAllowedOverlapping(
        events,
        record,
        updatedStart,
        updatedEnd
      );

      // Show alert if overlapping is allowed and the end time is after the start time, otherwise update events
      if (isAllowedOverlapping && end > start) {
        showAlert(arr, record, date, duration);
      } else {
        changeEvents(arr);
        shouldAddToChangedEvents(record, date, duration);
      }
    }
  };

  const checkIfAllowedOverlapping = (events, record, start, end) => {
    const isAllowed = isSchedulingAllowedOverlapping(
      events,
      record,
      start,
      end
    );
    const loadingHours = isLoadingHours(events, record, start, end);
    return isAllowed && loadingHours;
  };

  const showAlert = (arr, record, date, duration) => {
    const title = intl.formatMessage({
      id: "app.scheduling.overlappingEventsModalTitle",
    });
    const content = intl.formatMessage({
      id: "app.scheduling.overlappingEventsModalDescription",
    });
    modal.confirm({
      title: title,
      icon: <ExclamationCircleOutlined />,
      content: content,
      onOk() {
        if (duration > 0) {
          changeEvents(arr);
          return shouldAddToChangedEvents(record, date, duration);
        }
      },
      onCancel() {},
    });
  };
  const shouldAddToChangedEvents = (record, date, duration) => {
    const changedRecord = changedEvents.filter((i) => i.id === record.id)[0];
    const originalRecord = originalEvents.filter((i) => i.id === record.id)[0];

    if (
      originalRecord.date !== date ||
      originalRecord.duration_minutes !== duration
    ) {
      //record is changed
      setChangedEvents(
        changedRecord
          ? [
              ...changedEvents.filter((i) => i.id !== record.id),
              { ...changedRecord, date: date, duration_minutes: duration },
            ]
          : [
              ...changedEvents,
              {
                ...convertSchedulingEventsFromCalender({
                  ...record,
                }),
                id: record.id,
                date: date,
                duration_minutes: duration,
              },
            ]
      );
    } else {
      //record is same so we need to filter the changed event
      setChangedEvents(changedEvents.filter((i) => i.id !== record.id));
    }
  };

  const disabledStartHours = (record) => {
    // Check if the day of the "start" time is before the day of the "end" time
    if (moment(record["start"]).isBefore(moment(record["end"]), "day")) {
      return []; // Return empty array
    }
    if (record?.ok2go_info?.exit_date) {
      const endHour = moment(record?.ok2go_info?.exit_date).hour();
      return [...Array(24).keys()].filter((hour) => hour >= endHour);
    }
    return [];
  };

  const disabledStartMinutes = (selectedHour, record) => {
    // Check if the day of the "start" time is before the day of the "end" time
    if (moment(record["start"]).isBefore(moment(record["end"]), "day")) {
      return []; // Return empty array
    }
    if (record?.ok2go_info?.exit_date) {
      const endHour = moment(record?.ok2go_info?.exit_date).hour();
      const endMinute = moment(record?.ok2go_info?.exit_date).minute();
      if (selectedHour === endHour) {
        return [...Array(60).keys()].filter((minute) => minute >= endMinute);
      }
    }
    return [];
  };

  const disabledEndHours = (record) => {
    // Always allow midnight (00:00)
    let hours = [];

    // Check if current end time is midnight (00:00)
    const isEndMidnight =
      record["end"] &&
      moment(record["end"]).hours() === 0 &&
      moment(record["end"]).minutes() === 0;

    // If start and end are on different days, don't disable any hours
    if (
      moment(record["start"]).isBefore(moment(record["end"]), "day") &&
      !isEndMidnight
    ) {
      return [];
    }

    // Add disabled hours (excluding 00:00)
    for (var i = 1; i < moment(record["start"]).get("hour"); i++) {
      hours.push(i);
    }
    return hours;
  };

  const disabledEndMinutes = (selectedHour, record) => {
    var minutes = [];
    const startHour = moment(record["start"]).get("hour");
    const startMinutes = moment(record["start"]).get("minute");
    if (selectedHour === startHour) {
      for (var i = 0; i < startMinutes; i++) {
        minutes.push(i);
      }
    }

    // For midnight (00:00), don't disable only 00 minutes
    if (selectedHour === 0 && !(selectedHour === startHour)) {
      for (var i = 1; i < 60; i++) {
        minutes.push(i);
      }

      return minutes;
    }
    // Check if the day of the "start" time is before the day of the "end" time
    if (moment(record["start"]).isBefore(moment(record["end"]), "day")) {
      return []; // Return empty array
    }

    return minutes;
  };

  const onSortChange = (pagination, filters, sorter, extra) => {
    setActiveSorter(sorter["field"]);
  };

  const getApproveDate = () => {
    return allowUpfrontApproval
      ? moment().add(8, "days").endOf("day")
      : moment().endOf("day");
  };

  const branch_id =
    branchId || (employeeBranches?.length > 0 ? employeeBranches[0].id : null);

  const hasUnlockEventPermission = usePermission(
    branch_id,
    "patients",
    "unlock_event"
  );

  const getSelectedRowIds = (selectedRows) => {
    if (!selectedRows || selectedRows.length === 0) return [];
    return selectedRows.filter((row) => !row.titleRow).map((row) => row.id);
  };

  const getCheckboxProps = (record) => ({
    disabled: isSuperAdmin
      ? false
      : record.is_day_center ||
        record.salary_approved ||
        (!hasUnlockEventPermission &&
          (record.prospectus_id || record.titleRow)) ||
        (record?.ok2go_info?.id &&
          (!record?.ok2go_info?.date || !record?.ok2go_info?.exit_date)),
    name: record.name,
  });

  const renderCell = (checked, record, index, node) => {
    if (record.titleRow || record.absenceRow) {
      return null;
    }
    return node;
  };

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedKeys(selectedRowKeys);
      setSelectedRowKeys(getSelectedRowIds(selectedRows));
    },
    getCheckboxProps,
    renderCell,
  };

  const onSaveChanges = async (fromApproval) => {
    if (changedEvents.length > 0) {
      let changedKeys = [];
      const promises = changedEvents.map(async (item) => {
        const selectedEvent = items.filter((j) => +j.id === +item.id)[0];
        if (!selectedEvent) {
          return; //incase changed event is filtered we don't want to include it in the update
        }
        const order = orders
          ? orders.filter((i) => i.id === selectedEvent.order_id)[0]
          : null;
        const params = {
          patientId: fromEmployee
            ? selectedEvent.order.patient_id
            : order
            ? order.patient.id
            : null,
          branchId: fromEmployee
            ? selectedEvent.order.patient.branch
            : order
            ? order.patient.branch
            : null,
          schedulingEvent: { deleted: item.id, new: { ...item } },
        };
        const update = await dispatch(editSchedulingEvent(params));
        const newId =
          update.payload && update.payload.data ? update.payload.data.id : null;
        const selected = selectedRowKeys.filter((i) => +i === +item.id)[0];
        if (selected) {
          changedKeys.push({ new: newId, old: selected });
        }
        return update;
      });

      const action = await Promise.all(promises);
      if (!action.error) {
        setChangedEvents([]);
        if (fromApproval) {
          return changedKeys;
        } else {
          return reload();
        }
      } else {
        return;
      }
    }
  };
  const onApproveSelected = async (val) => {
    if (changedEvents && changedEvents.length > 0) {
      modal.confirm({
        title: intl.formatMessage({
          id: "app.scheduling.unsavedChangesTitle",
        }),
        icon: <ExclamationCircleOutlined />,
        content: intl.formatMessage({
          id: "app.scheduling.unsavedChangesContent",
        }),
        okText: intl.formatMessage({
          id: "app.scheduling.continueWithSaving",
        }),
        cancelText: intl.formatMessage({
          id: "app.scheduling.continueWithoutSaving",
        }),
        async onOk() {
          const changedKeys = await onSaveChanges(true);
          onSelectedApprove(val, changedKeys);
        },
        onCancel() {
          onSelectedApprove(val);
        },
      });
    } else {
      onSelectedApprove(val);
    }
  };

  const onSelectedApprove = async (val, changedKeys) => {
    onApprove(
      items,
      selectedRowKeys,
      fromEmployee,
      patientId,
      branchId,
      dispatch,
      approveEvent,
      reload,
      setSelectedRowKeys,
      setChangedEvents,
      changedKeys,
      (k) => moment(k.date) <= getApproveDate(),
      val
    );
  };

  const onUnlockConfirmed = async () => {
    return onAction(
      unlockEvents,
      items,
      selectedRowKeys,
      fromEmployee,
      patientId,
      branchId,
      dispatch,
      reload,
      setSelectedRowKeys,
      setChangedEvents,
      null,
      (k) => k.prospectus_id
    );
  };

  const onUnlockSelected = async () => {
    modal.confirm({
      title: intl.formatMessage({
        id: "app.scheduling.unlockEventsTitle",
      }),
      icon: <ExclamationCircleOutlined />,
      content: intl.formatMessage({
        id: "app.scheduling.unlockEventsContent",
      }),
      okText: intl.formatMessage({
        id: "app.actions.continue",
      }),
      cancelText: intl.formatMessage({
        id: "app.actions.cancel",
      }),
      async onOk() {
        await onUnlockConfirmed();
      },
      onCancel() {
        return;
      },
    });
  };

  const onTransferSelected = () => {
    setTransferModalVisible(true);
  };

  const handleTransfer = async (values) => {
    const { patient_id, order_id } = values;

    // Get the selected events that will be transferred
    const eventsToTransfer = items.filter((i) =>
      selectedRowKeys.includes(i.id)
    );

    // Transform each event into a ChangeEvent object
    const changeEvents = eventsToTransfer.map((event) => ({
      deleted: event.id,
      new: {
        ...event,
        order_id: order_id,
      },
    }));

    const params = {
      patientId: patient_id,
      scopePrefix,
      events: changeEvents,
    };

    const action = await dispatch(transferSchedulingEvents(params));
    if (!action.error) {
      setTransferModalVisible(false);
      reload();
      setSelectedRowKeys([]);
    }
  };

  const onDeleteSelected = async () => {
    if (changedEvents && changedEvents.length > 0) {
      modal.confirm({
        title: intl.formatMessage({
          id: "app.scheduling.unsavedChangesTitle",
        }),
        icon: <ExclamationCircleOutlined />,
        content: intl.formatMessage({
          id: "app.scheduling.unsavedChangesContent",
        }),
        okText: intl.formatMessage({
          id: "app.scheduling.continueWithSaving",
        }),
        cancelText: intl.formatMessage({
          id: "app.scheduling.continueWithoutSaving",
        }),
        async onOk() {
          const changedKeys = await onSaveChanges(true);
          onSelectedDelete(changedKeys);
        },
        onCancel() {
          onSelectedDelete();
        },
      });
    } else {
      modal.confirm({
        title: intl.formatMessage({
          id: "app.scheduling.deleteEvents",
        }),
        icon: <ExclamationCircleOutlined />,
        content: intl.formatMessage({
          id: "app.scheduling.deleteEventsContent",
        }),
        okText: intl.formatMessage({
          id: "app.actions.continue",
        }),
        cancelText: intl.formatMessage({
          id: "app.actions.cancel",
        }),
        async onOk() {
          onSelectedDelete();
        },
        onCancel() {
          return;
        },
      });
    }
  };

  const onSelectedDelete = async (changedKeys) => {
    return onAction(
      deleteEvents,
      items,
      selectedRowKeys,
      fromEmployee,
      patientId,
      branchId,
      dispatch,
      reload,
      setSelectedRowKeys,
      setChangedEvents,
      changedKeys,
      (k) => k.approved !== true && !k?.ok2go_info?.id //filter out approved events and ok2go events
    );
  };

  const onDeleteEvent = (record) => {
    const title = intl.formatMessage({
      id: "app.scheduling.table.deleteHouseVisitTitle",
    });
    const content = intl.formatMessage({
      id: "app.scheduling.table.deleteHouseVisitContent",
    });
    modal.confirm({
      title: title,
      icon: <ExclamationCircleOutlined />,
      content: content,
      onOk() {
        return onConfirm(record);
      },
      onCancel() {},
    });
  };

  const onShowEmployeeScheduling = (record) => {
    setSelectedDay(record.date);
    setSelectedEmployee(record.employee);
    setVisible(true);
  };

  const onHide = () => {
    setVisible(false);
  };

  const onConfirm = async (record) => {
    const selectedEvent = events.filter((j) => +j.id === +record.id)[0];
    const order = orders
      ? orders.filter((i) => i.id === selectedEvent.order_id)[0]
      : null;
    const params = {
      patientId: fromEmployee
        ? selectedEvent.order.patient_id
        : order
        ? order.patient.id
        : null,
      branchId: fromEmployee
        ? selectedEvent.order.patient.branch
        : order
        ? order.patient.branch
        : null,
      schedulingEvent: { deleted: record.id },
    };
    const action = await dispatch(deleteSchedulingEvent(params));
    if (!action.error) {
      reload();
    }
  };

  const actionsFooter = () => (
    <SelectionActions
      selectedRowKeys={selectedRowKeys}
      changedEvents={changedEvents}
      onSaveChanges={onSaveChanges}
      onApproveSelected={onApproveSelected}
      onUnlockSelected={onUnlockSelected}
      onDeleteSelected={onDeleteSelected}
      onTransferSelected={onTransferSelected}
      branchId={branchId}
      items={items}
    />
  );

  const showFooter =
    (selectedRowKeys && selectedRowKeys.length > 0) || changedEvents.length > 0;

  const tableProps = {
    footer: showFooter ? actionsFooter : undefined,
  };

  // Helper function after the existing useEffect hooks
  const extendEmployeeConflicts = (employee_conflicts) => {
    const result = {};

    // If either input is missing, return empty object
    if (!employee_conflicts || !events) return {};

    // Iterate over each conflict group
    Object.entries(employee_conflicts).forEach(([eventId, conflicts]) => {
      // For each conflict in the array, find its matching item and extend it
      result[eventId] = conflicts.map((conflict) => {
        // Find the matching item by conflict's ID
        const matchingItem = events.find((item) => item.id === conflict.id);

        return {
          ...conflict,
          order: matchingItem?.order, // Add the order from the matching item if found
        };
      });
    });

    return result;
  };

  const extendedEmployeeConflicts = extendEmployeeConflicts(employee_conflicts);

  return (
    <SchedulingApprovalWrapper>
      {contextHolder}
      <div
        onKeyDown={handleKeyPress}
        style={{ height: "100%", overflow: "hidden" }}
      >
        <div
          direction="horizontal"
          size="middle"
          align="start"
          style={{ width: "100%", height: "100%", display: "flex" }}
        >
          {showTimewatchEvents && timewatchEvents?.length > 0 && (
            <div
              style={{
                flexShrink: 0,
                width: "340px",
                overflowY: "auto",
                height: "100%",
                padding: "0 10px",
              }}
            >
              <TimewatchEventsTable
                timewatchEvents={timewatchEvents}
                isLoadingTimewatch={isLoadingTimewatch}
                holidays={holidays}
                branchId={branchId}
                currentDate={currentDate}
                reload={reload}
              />
            </div>
          )}
          <div style={{ flex: 1, overflow: "auto", height: "100%" }}>
            <Table
              bordered
              className={
                quickEdit
                  ? "scheduling-approval edit-mode"
                  : "scheduling-approval"
              }
              pagination={false}
              rowSelection={rowSelection}
              columns={getApprovalColumns(
                quickEdit,
                intl,
                fromEmployee,
                conflict_events,
                onDateChange,
                onChange,
                disabledEndHours,
                disabledEndMinutes,
                disabledStartHours,
                disabledStartMinutes,
                onConfirm,
                holidays,
                religionId,
                onDeleteEvent,
                onShowEmployeeScheduling,
                timewatchEvents,
                extendedEmployeeConflicts
              )}
              size={quickEdit ? "small" : "small"}
              dataSource={items}
              rowKey={(record) => record.id}
              scroll={{
                x: window.innerWidth - 800,
                y: showFooter
                  ? window.innerHeight - 270
                  : window.innerHeight - 220,
              }}
              loading={loadLoading}
              onChange={onSortChange}
              rowClassName={(record, index) =>
                record.mainTitle
                  ? "main_title"
                  : record.titleRow
                  ? "week_number_row"
                  : ""
              }
              {...tableProps}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
      <EmployeeSchedulingModal
        employee={selectedEmployee}
        startDate={moment(selectedDay).startOf("day").format()}
        endDate={moment(selectedDay).endOf("day").format()}
        onHide={onHide}
        visible={visible}
      />
      <TransferModal
        visible={transferModalVisible}
        onHide={() => setTransferModalVisible(false)}
        onTransfer={handleTransfer}
        items={items}
        selectedRowKeys={selectedRowKeys}
      />
    </SchedulingApprovalWrapper>
  );
};

export default SchedulingApproval;
